import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const financialConfig: PageConfig[] = [
  {
    name: "expenditure",
    title: "Expenditure",
    questions: [
      {
        type: "matrixdynamic",
        name: "expenditure",
        title: "Expenditure",
        description: "All $ Ex GST",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        columns: [
          {
            name: "expenditureType",
            title: "Expenditure Type",
            isRequired: true,
            choices: [
              "Communications",
              "Catering",
              "Transport",
              "Venue Hire",
              "Equipment Hire / Purchase",
              "Other",
            ],
          },
          {
            name: "expenditureDetails",
            title: "Description or Provider Name",
            cellType: "text",
            isRequired: true,
          },
          {
            name: "expenditureAmount",
            title: "Amount",
            cellType: "text",
            isRequired: true,
            totalType: "sum",
            // eslint-disable-next-line no-template-curly-in-string
            totalFormat: "Total: ${0}",
            inputType: "number",
            totalAlignment: "right",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
  {
    name: "financialSummary",
    title: "Financial Summary",
    questions: [
      {
        type: "expression",
        name: "summaryExpenditure",
        title: "Total Event Cost",
        expression: "{expenditure-total.expenditureAmount}",
        displayStyle: "currency",
        currency: "NZD",
      },
      {
        type: "expression",
        name: "summaryIncome",
        title: "Rangitāne Funding Received",
        expression: "{amount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
      {
        type: "expression",
        name: "balance",
        title: "Balance",
        expression:
          "{expenditure-total.expenditureAmount} - {amount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
    ],
  },
  {
    name: "receipts",
    title: "Receipts",
    questions: [
      {
        type: "file",
        name: "receipts",
        title: "Please attach GST receipts for all expenses.",
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
    ],
  },
  {
    name: "fundUse",
    title: "Use of Funds",
    questions: [
      {
        name: "fundUse",
        title:
          "Were all funds from the Whānau Initiatives Fund used as agreed?",
        type: "radiogroup",
        choices,
        isRequired: true,
      },
      {
        name: "alternateFundUse",
        title: "Please provide details of funds not used as agreed.",
        type: "comment",
        visibleIf: "{fundUse} = 'Kāo'",
        isRequired: true,
      },
    ],
  },
];
